import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetPermissionsList } from "../Responses/GetPermissionsList";

export async function getPermissionsList(data) {
	let response = await getAPIResponse("/v1/permission-list", data);
	if (response === null) {
		return null;
	}
	let getPermissionsList = GetPermissionsList.createFromResponseData(response);
	return getPermissionsList;
}